import {
  TOGGLE_ALERT,
  SHOW_OVERLAY_FILTERS,
  HIDE_OVERLAY_FILTERS
} from '../actions/ui';

export default function (state = {}, action) {
  switch (action.type) {
  case TOGGLE_ALERT:
    return { ...state, alertMessage: action.message, error: action.error };
  case SHOW_OVERLAY_FILTERS:
    return { ...state, showColumnFilters: true };
  case HIDE_OVERLAY_FILTERS:
    return { ...state, showColumnFilters: false };
  default:
    return state;
  }
}
